import { sendStructEvent } from '../../api';
import { EventProperty } from '../../types';

interface PayloadModel {
    eventAction: string;
    eventLabel: string;
    eventCategory: string;
    eventProperty: EventProperty;
}

export const sendLandingPageCtaClickEvent = (payload: PayloadModel): void => {
    const { eventLabel, eventAction, eventProperty, eventCategory } = payload;
    sendStructEvent({
        eventCategory,
        eventAction,
        eventLabel,
        eventProperty,
    });
};
